export default "__VITE_ASSET__CNUrjGQP__"